<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="cost-invoices-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Faktury kosztowe</h1>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="invoices"
      class="elevation-1"
      :loading="loading"
      :search="search"
      :options.sync="options"
      :server-items-length="totalItems"
    >
      <template v-slot:top>
        <div class="table-section-title">
          <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-receipt-text</v-icon></div>
          <div class="filter-title">{{ $t('costInvoices.title') }}</div>
          <v-spacer></v-spacer>
          <button class="action-pill action-pill--primary" @click="((dialog = true), (currentInvoiceId = null))">
            <v-icon left small>mdi-plus</v-icon>
            {{ $t('common.add') }}
          </button>
        </div>
            <div>
              <v-row class="mx-2">
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="search"
                    :label="$t('common.search')"
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu
                    ref="startDateMenu"
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    content-class="dark-date-picker"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="startDate"
                        :label="$t('common.dateFrom')"
                        outlined
                        dense
                        hide-details
                        readonly
                        clearable
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="clearStartDate"
                      />
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      no-title
                      scrollable
                      first-day-of-week="1"
                      :locale="$i18n.locale"
                      @input="startDateMenu = false"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4">
                  <v-menu
                    ref="endDateMenu"
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    content-class="dark-date-picker"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="endDate"
                        :label="$t('common.dateTo')"
                        outlined
                        dense
                        hide-details
                        readonly
                        clearable
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="clearEndDate"
                      />
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      no-title
                      scrollable
                      first-day-of-week="1"
                      :locale="$i18n.locale"
                      @input="endDateMenu = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip x-small :color="statusColor(item.status)" text-color="white" class="font-weight-bold">
              {{ statusLabel(item.status) }}
            </v-chip>
          </template>
          <template v-slot:item.details="{ item }">
            <v-btn class="warning" @click="infoInvoice(item.id)"
              ><v-icon small class="pt-1">mdi-pencil</v-icon></v-btn
            >
          </template>
          <template v-slot:item.deleteInvoice="{ item }">
            <v-btn class="error" @click="deleteInvoice(item.id)"
              ><v-icon small class="pt-1">mdi-delete</v-icon></v-btn
            >
          </template>
        </v-data-table>
    <v-dialog content-class="dark-form-dialog" v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('costInvoices.uploadTitle') }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" @submit.prevent="submitInvoice">
            <v-row>
              <!-- File Upload with Preview -->
              <v-col cols="12">
                <v-file-input
                  v-model="invoice.file"
                  :label="$t('costInvoices.file')"
                  outlined
                  accept="image/*,.pdf, image/*"
                  @change="previewFile"
                />
                <iframe
                  v-if="invoice.preview"
                  :src="invoice.preview"
                  style="width: 100%; height: 400px"
                  frameborder="0"
                ></iframe>
              </v-col>
              <!-- Date -->
              <v-col cols="12" md="12">
                <v-menu
                  ref="dateMenu"
                  v-model="menuDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="invoice.date"
                      :label="$t('common.date')"
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[validateRequired]"
                    />
                  </template>
                  <v-date-picker
                    v-model="invoice.date"
                    no-title
                    scrollable
                    first-day-of-week="1"
                    :locale="$i18n.locale"
                    @input="menuDate = false"
                  />
                </v-menu>
              </v-col>
              <!-- Brutto Input -->
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="invoice.name"
                  :label="$t('common.description')"
                  outlined
                  required
                  type="text"
                  :rules="[validateRequired]"
                />
              </v-col>

              <!-- Brutto Input -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="invoice.brutto23"
                  :label="$t('costInvoices.brutto23')"
                  outlined
                  type="number"
                  @input="calculateNetto23"
                />
              </v-col>


              <!-- Netto (Calculated) -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="invoice.netto23"
                  :label="$t('costInvoices.netto23')"
                  outlined
                  readonly
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="invoice.brutto8"
                  :label="$t('costInvoices.brutto8')"
                  outlined
                  type="number"
                  @input="calculateNetto8"
                />
              </v-col>


              <!-- Netto (Calculated) -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="invoice.netto8"
                  :label="$t('costInvoices.netto8')"
                  outlined
                  readonly
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="invoice.brutto5"
                  :label="$t('costInvoices.brutto5')"
                  outlined
                  type="number"
                  @input="calculateNetto5"
                />
              </v-col>


              <!-- Netto (Calculated) -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="invoice.netto5"
                  :label="$t('costInvoices.netto5')"
                  outlined
                  readonly
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="invoice.brutto0"
                  :label="$t('costInvoices.brutto0')"
                  outlined
                  type="number"
                  @input="calculateNetto0"
                />
              </v-col>


              <!-- Netto (Calculated) -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="invoice.netto0"
                  :label="$t('costInvoices.netto0')"
                  outlined
                  readonly
                />
              </v-col>


              <v-col cols="12" md="12">
                <v-select
                  v-model="invoice.type"
                  :items="invoiceType"
                  :label="$t('common.status')"
                  outlined
                  required
                  :rules="[validateRequired]"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
                  <v-spacer></v-spacer>
          <!-- Cancel Button -->
          <v-btn text color="secondary" @click="dialog = false">{{ $t('common.cancel') }}</v-btn>
          <!-- Submit Button -->
          <v-btn color="primary" :disabled="!valid" @click="submitInvoice">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
const axios = require("axios");
import * as dayjs from "dayjs";
export default {
  data() {
    return {
      currentInvoiceId: null,
      loading: false,
      totalItems: 0,
      search: "",
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      invoices: [],
      menuDate: false,
      headers: [
        {
          text: "Data",
          align: "start",
          sortable: false,
          value: "date",
        },
        {
          text: "Brutto (23%)",
          align: "start",
          sortable: false,
          value: "brutto23",
        },
        {
          text: "Netto (23%)",
          align: "start",
          sortable: false,
          value: "netto23",
        },
        {
          text: "Brutto (8%)",
          align: "start",
          sortable: false,
          value: "brutto8",
        },
        {
          text: "Netto (8%)",
          align: "start",
          sortable: false,
          value: "netto8",
        },
        {
          text: "Brutto (5%)",
          align: "start",
          sortable: false,
          value: "brutto5",
        },
        {
          text: "Netto (5%)",
          align: "start",
          sortable: false,
          value: "netto5",
        },
        {
          text: "Brutto (0%)",
          align: "start",
          sortable: false,
          value: "brutto0",
        },
        {
          text: "Netto (0%)",
          align: "start",
          sortable: false,
          value: "netto0",
        },
        {
          text: "Status",
          align: "start",
          sortable: false,
          value: "status",
        },
        { text: "", value: "details", sortable: false },
        { text: "", value: "deleteInvoice", sortable: false },
      ],
      dialog: false,
      valid: false,
      invoice: {
        name: null,
        type: null,
        date: null,
        file: null,
        preview: null,
        brutto23: 0,
        brutto8: 0,
        brutto5: 0,
        brutto0: 0,
        netto23: 0,
        netto8: 0,
        netto5: 0,
        netto0: 0,
      },
      invoiceType: [
        { text: "Oczekujący", value: "PENDING" },
        { text: "Wypłata utworzona", value: "PAYOUT_CREATED" },
        { text: "Zapłacony", value: "PAID" },
      ],
    };
  },
  async created() {
    await this.initialize();
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    search: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    startDate: {
      handler() {
        this.initialize();
      },
    },
    endDate: {
      handler() {
        this.initialize();
      },
    },
  },
  methods: {
    statusLabel(status) {
      return ({
        PENDING: 'Oczekujący',
        PAYOUT_CREATED: 'Wypłata utworzona',
        PAID: 'Zapłacony',
      })[status] || status || '—';
    },
    statusColor(status) {
      return ({
        PENDING: 'warning',
        PAYOUT_CREATED: 'info',
        PAID: 'success',
      })[status] || 'grey';
    },
    async toggleLoading(type) {
      const toggle = type;
      localStorage.setItem("loading", toggle);
      window.dispatchEvent(
        new CustomEvent("toggleLoading", {
          detail: {
            loading: localStorage.getItem("loading"),
            overlay: localStorage.getItem("loading"),
          },
        })
      );
    },
    validateRequired(value) {
      return !!value || "To pole jest wymagane";
    },
    clearStartDate() {
      this.startDate = null;
    },
    clearEndDate() {
      this.endDate = null;
    },
    previewFile(file) {
      console.log(file);
      if (file && file instanceof File) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.invoice.preview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    calculateNetto0() {
        const taxMultiplier = 1 + 0 / 100;
        this.invoice.netto0 = (this.invoice.brutto0 / taxMultiplier).toFixed(2);

    },
    calculateNetto23() {
        const taxMultiplier = 1 + 23 / 100;
        this.invoice.netto23 = (this.invoice.brutto23 / taxMultiplier).toFixed(2);
      
    },
    calculateNetto8() {
       const taxMultiplier = 1 + 8 / 100;
        this.invoice.netto8 = (this.invoice.brutto8 / taxMultiplier).toFixed(2);
      
    },
    calculateNetto5() {
        const taxMultiplier = 1 + 5 / 100;
        this.invoice.netto5 = (this.invoice.brutto5 / taxMultiplier).toFixed(2);
      
    },
    async submitInvoice() {
      // Process the invoice data here
      await this.toggleLoading(true);
      if (!this.valid) return;
      // Combine predefined metadata with additional metadata
      const formData = new FormData();
      try {
        formData.append("file", this.invoice.file, this.invoice.file.name);
      } catch (e) {
        console.log("Missing Image");
      }
      formData.append("id", this.currentInvoiceId || undefined);
      formData.append("name", this.invoice.name);
      const num = (v) => {
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : 0;
      };
      formData.append("brutto23", num(this.invoice.brutto23));
      formData.append("brutto8", num(this.invoice.brutto8));
      formData.append("brutto5", num(this.invoice.brutto5));
      formData.append("brutto0", num(this.invoice.brutto0));
      formData.append("netto23", num(this.invoice.netto23));
      formData.append("netto8", num(this.invoice.netto8));
      formData.append("netto5", num(this.invoice.netto5));
      formData.append("netto0", num(this.invoice.netto0));
      formData.append("date", this.invoice.date);
      formData.append("status", this.invoice.type);
      try {
        await axios({
          method: "post",
          url: process.env.VUE_APP_ROOT_API + "cost-invoices",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        });
        await this.initialize();
        this.closeDialog();
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      await this.toggleLoading(false);
    },
    async initialize() {
      this.loading = true;
      if (this.search.trim().length > 0) {
        this.options.page = 1;
      }
      try {
        let url = process.env.VUE_APP_ROOT_API +
          `cost-invoices/all?take=${this.options.itemsPerPage}&skip=${this.options.page}&search=${this.search}`;

        if (this.startDate) {
          url += `&startDate=${this.startDate}`;
        }
        if (this.endDate) {
          url += `&endDate=${this.endDate}`;
        }

        const invoices = await axios({
          method: "get",
          url: url,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.invoices = invoices.data.data.result.map((bonus) => {
          return {
            brutto23: bonus.brutto23 / 100,
            brutto8: bonus.brutto8 / 100,
            brutto5: bonus.brutto5 / 100,
            brutto0: bonus.brutto0 / 100,
            netto23: bonus.netto23 / 100,
            netto8: bonus.netto8 / 100,
            netto5: bonus.netto5 / 100,
            netto0: bonus.netto0 / 100,
            status: bonus.status,
            date: dayjs(bonus.date).format("DD-MM-YYYY"),
            id: bonus.id,
          };
        });
        this.totalItems = invoices.data.data.count;
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      this.loading = false;
    },
    async deleteInvoice(id) {
      Swal.fire({
        title: "Napewno usunąć?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tak",
        cancelButtonText: "Anuluj",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios({
              method: "delete",
              url: process.env.VUE_APP_ROOT_API + "cost-invoices/" + id,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            await this.initialize();
          } catch (e) {
            console.log(e);
            Swal.fire("Błąd", e.response.data.message.toString(), "error");
          }
        }
      });
    },
    async infoInvoice(id) {
      await this.toggleLoading(true);
      try {
        const invoices = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "cost-invoices/details/" + id,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.currentInvoiceId = invoices.data.data.id;
        this.invoice.date = dayjs(invoices.data.data.date).format("YYYY-MM-DD");
        this.invoice.name = invoices.data.data.name;
        this.invoice.brutto23 = invoices.data.data.brutto23 / 100;
        this.invoice.brutto8 = invoices.data.data.brutto8 / 100;
        this.invoice.brutto5 = invoices.data.data.brutto5 / 100;
        this.invoice.brutto0 = invoices.data.data.brutto0 / 100;
        this.invoice.netto23 = invoices.data.data.netto23 / 100;
        this.invoice.netto8 = invoices.data.data.netto8 / 100;
        this.invoice.netto5 = invoices.data.data.netto5 / 100;
        this.invoice.netto0 = invoices.data.data.netto0 / 100;
        this.invoice.type = invoices.data.data.status;
        this.dialog = true;
        await this.toggleLoading(false);
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    closeDialog() {
      this.dialog = false;
      this.currentInvoiceId = undefined;
      this.$refs.form.resetValidation(); // Reset form validation
    },
  },
};
</script>

<style scoped>
.cost-invoices-page {
  margin: -24px;
  padding: 24px;
  background: #181C28;
  min-height: calc(100vh - 64px);
  color: #E6EAF2;
}
.page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-eyebrow {
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5478FF;
  font-weight: 600;
}
.page-title {
  font-size: 28px;
  font-weight: 700;
  margin: 4px 0 0 0;
  color: #FFFFFF;
}
.table-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #2A3142;
}
.filter-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(84, 120, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}
.filter-title {
  font-size: 15px;
  font-weight: 600;
  color: #E6EAF2;
}
.action-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
}
.action-pill--primary { background: #5478FF; color: #FFFFFF; }
.action-pill--primary:hover { background: #3F62E8; }
.cost-invoices-page >>> .v-data-table {
  background: #232838 !important;
  color: #E6EAF2 !important;
  border-radius: 12px;
  border: 1px solid #2A3142;
}
.cost-invoices-page >>> .v-data-table thead tr th {
  background: #1F2433 !important;
  color: #94A0B8 !important;
  border-bottom: 1px solid #2A3142 !important;
}
.cost-invoices-page >>> .v-data-table tbody tr td {
  border-bottom: 1px solid #2A3142 !important;
  color: #E6EAF2 !important;
}
.cost-invoices-page >>> .v-data-table tbody tr:hover {
  background: rgba(84, 120, 255, 0.06) !important;
}
.cost-invoices-page >>> .v-text-field--outlined fieldset {
  border-color: #2A3142 !important;
}
.cost-invoices-page >>> .v-text-field input,
.cost-invoices-page >>> .v-text-field textarea,
.cost-invoices-page >>> .v-select__selection {
  color: #E6EAF2 !important;
}
.cost-invoices-page >>> .v-label {
  color: #94A0B8 !important;
}
.cost-invoices-page >>> .v-dialog .v-card {
  background: #232838 !important;
  color: #E6EAF2 !important;
}
.cost-invoices-page >>> .v-card__title,
.cost-invoices-page >>> .v-card__text {
  color: #E6EAF2 !important;
}
</style>
